import PropTypes from 'prop-types';

export const BusyCallIcon = (props) => {
  const { className = '', style = {} } = props;

  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect width="30" height="30" rx="15" fill="#F5A623" />
      <path
        d="M9.5 18.75C8.8 18.2 8.38 17.15 8.38 16.05V12.65C8.38 11.56 9.27 10.68 10.36 10.68H19.64C20.73 10.68 21.62 11.56 21.62 12.65V16.05C21.62 17.15 21.2 18.2 20.5 18.75L18.95 20.02C18.58 20.3 18.12 20.47 17.66 20.47H12.34C11.88 20.47 11.42 20.3 11.05 20.02L9.5 18.75Z"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10.68V7.5C12.5 6.95 12.95 6.5 13.5 6.5H16.5C17.05 6.5 17.5 6.95 17.5 7.5V10.68"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.75 17.75L20.25 7.25" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

BusyCallIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
